<template>

      <div class="head">
        <div class="headTop clearfix">
          <div class="headTopTitle">{{publicData.Name}}</div>
          <div class="headTopIcon saber" @click="menu"><img :src="headTopIcon" alt=""></div>
        </div>
        <div class="headMenu" :class="{'headMenuShow':menuControl}" style="z-index: 2;">
          <h5 class="clearfix"><div class="headMenuClose" @click="menu"><img :src="headMenuClose" alt=""></div></h5>
          <ul>
            <!--<li class="headMenuFrist"><div class=""><img src="" alt=""></div></li>-->
            <li v-for="nav in navs" @click="menu">
              <router-link :to="{path:nav.path,query:nav.query}">{{nav.name}}</router-link>
            </li>
            <!--<li>车型展示</li>-->
            <!--<li>成功案列</li>-->
            <!--<li>服务范围</li>-->
            <!--<li>租车须知</li>-->
            <!--<li>新闻中心</li>-->
            <!--<li>联系我们</li>-->
          </ul>
        </div>
        <c_Mask v-if="menuControl"></c_Mask>
      </div>



</template>

<script>
    import c_Mask from '@/components/Mask/Mask'
    export default {
        name: 'Head',
        props:['publicData','cityCode'],
        components:{c_Mask},
        data () {
          return {
            headTopIcon: require("../../assets/icon_headMenu.png"),
            headMenuClose:require("../../assets/icon_headMenuClose.png"),
            menuControl:false,
            navs:[
              {name:'首页',path:'/',query:{cityCode:this.cityCode}},
              {name:'车型展示',path:'/Second',query:{cityCode:this.cityCode}},
              {name:'成功案列',path:'/SuccessCase',query:{cityCode:this.cityCode}},
              {name:'服务范围',path:'/ScopeService',query:{cityCode:this.cityCode}},
              {name:'租车须知',path:'/FourPage',query:{cityCode:this.cityCode}},
              {name:'新闻中心',path:'/NewsCenter',query:{cityCode:this.cityCode}},
              {name:'联系我们',path:'/NavContactUs',query:{cityCode:this.cityCode}}
            ]
          };
        },
        methods:{
          menu:function(el){
            let skt = this.menuControl;
            if(skt==false){
              this.menuControl =! this.menuControl;
              el.target.parentElement.parentElement.nextSibling.nextSibling.style.zIndex=5;
            }
            else {
              this.menuControl =! this.menuControl;
            }
          },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear{overflow: hidden;}
    .clearfix:before,.clearfix:after{clear:both;content:" ";display:table;}

    /*.head{position: relative}*/
    .headTop{height: 90px;line-height: 90px;}
    .headTopTitle{float: left;padding-left: 48px;font-size:36px;font-family:PingFangSC-Semibold;font-weight:600;color:rgba(44,62,80,1);}
    .headTopIcon{float: right;width: 120px;height: 100%;background: #1dd2af;}
     /*.saber{filter:blur(1px);}*/

    .headTopIcon img{width: 48px;height: 48px;vertical-align: middle}

    .headMenu{position: fixed;width: 100%;top: 0;right: -100%;transition:right .5s;z-index: 5}
    .headMenuShow{right: 0}
    .headMenu ul li{height: 80px;line-height: 80px;background: #1dd2af;font-size:32px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(255,255,255,1);border-bottom: 1px solid #fff;
      box-shadow:0px -2px 0px 0px rgba(255,255,255,1);text-align: left;padding-left: 32px;box-sizing: border-box}
    .headMenu ul li:last-child{border-bottom: none}
    .headMenu h5{height: 90px;line-height: 90px;background:rgba(0,0,0,0.5);margin: 0}
    .headMenuClose{float: right;width: 120px;height: 90px;}
    .headMenuClose img{width: 48px;height: 48px;vertical-align: middle}
</style>
<style>
  .headMenu ul li a{display: block;color: #fff;}

</style>



// WEBPACK FOOTER //
// src/components/Head/Head.vue